export const ADD_QUESTION = 'ADD_QUESTION'
export const REPLACE_QUESTION = 'REPLACE_QUESTION'
export const REMOVE_QUESTION = 'REMOVE_QUESTION'
export const EDIT_QUESTION = 'EDIT_QUESTION'
export const SUBMIT_ASSESSMENT = 'SUBMIT_ASSESSMENT'
export const CLEAR = 'CLEAR'
